import React from 'react';
import Navbar from '../components/Navbar';
import { Github, Linkedin, Instagram } from 'lucide-react';

const Socials = () => {
  return (
    <div className="min-h-screen bg-gray-50 overflow-hidden">
      {/* Mobile Navbar */}
      <div className="md:hidden">
        <Navbar dark={false} mobile={true} />
      </div>
      
      {/* Desktop Navbar */}
      <div className="hidden md:block">
        <Navbar dark={false} />
      </div>
      
      <div className="container mx-auto px-8 py-16 max-w-4xl">
        {/* Social Media Links */}
        <div className="flex flex-col items-center space-y-6 mb-20">
          <a 
            href="https://github.com/RoyArkh" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center space-x-3 text-xl font-light text-gray-800 hover:underline transition-all"
          >
            <Github className="w-6 h-6" />
            <span>GitHub</span>
          </a>
          
          <a 
            href="https://www.linkedin.com/in/roya-arkh/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center space-x-3 text-xl font-light text-gray-800 hover:underline transition-all"
          >
            <Linkedin className="w-6 h-6" />
            <span>LinkedIn</span>
          </a>
          
          <a 
            href="https://www.instagram.com/royaarkh/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center space-x-3 text-xl font-light text-gray-800 hover:underline transition-all"
          >
            <Instagram className="w-6 h-6" />
            <span>Instagram</span>
          </a>
        </div>
        
        {/* Also Check Out Section */}
        <div className="text-center">
          <h2 className="text-2xl font-light mb-8">Also Check Out</h2>
          
          <div className="flex flex-col items-center space-y-4">
            <a 
              href="https://mysite.ku.edu.tr/emregursoy/spade-lab/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-xl font-light text-gray-800 hover:underline transition-all"
            >
              Spade Lab
            </a>
            
            <a 
              href="https://www.linkedin.com/in/k-burak-yilmaz/?original_referer=https%3A%2F%2Fwww%2Egoogle%2Ecom%2F&originalSubdomain=tr" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-xl font-light text-gray-800 hover:underline transition-all"
            >
              Kerem Burak Yilmaz
            </a>
        
            <a 
              href="https://www.facebook.com/gul.san.arhmamedova" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-xl font-light text-gray-800 hover:underline transition-all"
            >
              Gulshan Arkhmammadova
            </a>

            <a 
              href="https://www.facebook.com/asifdent/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-xl font-light text-gray-800 hover:underline transition-all"
            >
              Asif Arkhmammadov
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Socials;